<template>
  <div>
    <h1 slot="title" class="page-title">Add Witness</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <div class="form-horizontal">
              <selectlist
                :options="titles"
                v-model="form.title_id"
                label="Title"
                placeholder="Please Select"
                name="title_id"
              ></selectlist>

              <inputbox
                v-model="form.first_name"
                name="first_name"
                label="First Name"
              ></inputbox>

              <inputbox
                v-model="form.last_name"
                name="last_name"
                label="Last Name"
              ></inputbox>

              <inputbox
                v-model="form.telephone"
                name="telephone"
                label="Telephone"
              ></inputbox>

              <inputbox
                v-model="form.email_address"
                name="email"
                label="Email Address"
                type="email"
              ></inputbox>

              <address-lookup
                :address="address"
                v-on:address="setAddress"
              ></address-lookup>

              <toggleswitch
                :labels="true"
                name="corroborate"
                label="Corroborate Clients Version of Events?"
                v-model="form.corroborate"
              ></toggleswitch>
            </div>
          </div>
          <div class="card-footer text-right">
            <button
              class="btn btn-danger btn-raised float-left"
              name="cancel"
              v-on:click.prevent="cancel"
            >
              <i class="icon icon-cancel"></i> Cancel
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="submit"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      titles: [],
      client: null,
      form: new window.Form({
        title_id: null,
        first_name: null,
        last_name: null,
        telephone: null,
        email_address: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        corroborate: true
      })
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/titles')
        .then(response => {
          this.titles = response.data;
        })
        .catch(error => {});
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    submit() {
      this.form
        .post('/incidents/' + this.incident + '/witnesses')
        .then(response => {
          this.$emit('added', response);
          this.$router.push(
            `/first-notice-of-loss-plus/${this.incident}#parties`
          );
        })
        .catch(error => {});
    },

    cancel() {
      this.$router.push(`/first-notice-of-loss-plus/${this.incident}#parties`);
    }
  }
};
</script>
